import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import React from 'react';
import noDataPic from '../../../../Assets/NoData.svg';
import style from './DisplayValue.module.css';
import { FormattedMessage } from 'react-intl';
import {
  parseFixedString,
  PERCENTAGE_TABLE,
  TIME_TABLE,
  MetricBooleanMap,
  extractGeneralMetricValue,
} from './helper';
import { GeneralMetricType } from './types';

interface DisplayValueProp {
  metricType: string;
  metrics: GeneralMetricType;
  responsiveFont: boolean;
}

const STYLE_COLOR = '#077398';
const STYLE_FONT_SIZE = '18px';

const DisplayValue: React.FC<DisplayValueProp> = ({
  metricType,
  metrics,
  responsiveFont,
}: DisplayValueProp): React.ReactElement => {
  const datapoint = extractGeneralMetricValue(metrics);

  if (datapoint === null) {
    return (
      <Row spacing='none' spacingInset='none' alignmentHorizontal='start'>
        <img src={noDataPic} className={style.noData} alt='No data' />
      </Row>
    );
  }

  const isTime = TIME_TABLE[metricType as keyof MetricBooleanMap];
  const isPercentage = PERCENTAGE_TABLE[metricType as keyof MetricBooleanMap];
  let parsedValue: number;
  let parsedString: string;

  if (isTime) {
    parsedString = datapoint + ' ';
  } else {
    parsedValue = parseFloat(datapoint!);

    if (isNaN(parseFloat(datapoint!))) {
      return <></>;
    }

    parsedString = parseFixedString(parsedValue, isPercentage, false);
  }

  return (
    <Row spacing='none' spacingInset='none' alignmentHorizontal='start'>
      <Text type={!responsiveFont ? 'h300' : 'd50'}>
        <b>
          <span
            style={{
              color: STYLE_COLOR,
              position: 'relative',
              top: !responsiveFont ? '-1px' : '-10px',
              marginRight: -18,
            }}
          >
            {parsedString!}
          </span>

          {isTime && (
            <span
              style={{
                fontSize: !responsiveFont ? '16px' : STYLE_FONT_SIZE,
                lineHeight: !responsiveFont ? '20px' : '28px',
                color: STYLE_COLOR,
                position: 'relative',
                top: !responsiveFont ? '-1px' : '-10px',
                marginLeft: 10,
              }}
            >
              <FormattedMessage id='cs_perfportal_min' defaultMessage='min' />
            </span>
          )}
        </b>
      </Text>
    </Row>
  );
};

export default DisplayValue;
